import { gql } from "@apollo/client";

export const GetItemErrorMsgs = gql`
  query GetItemErrorMsgs(
    $token: String!
    $customerID: ID!
    $itemID: ID!
    $itemDetailsID: ID!
  ) {
    GetItemErrorMsgs(
      token: $token
      customerID: $customerID
      itemID: $itemID
      itemDetailsID: $itemDetailsID
    ) {
      id
      errMsg
      idx
      isActive
      customerID
      itemID
    }
  }
`;
